import { render } from "./ReclamacaoTecnicaComercialPDF.vue?vue&type=template&id=8a69268a&scoped=true"
import script from "./ReclamacaoTecnicaComercialPDF.vue?vue&type=script&lang=js"
export * from "./ReclamacaoTecnicaComercialPDF.vue?vue&type=script&lang=js"

import "./ReclamacaoTecnicaComercialPDF.vue?vue&type=style&index=0&id=8a69268a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a69268a"]])

export default __exports__